import Axios from "axios";
import {
  SET_WORKFORCE_AVAILABILITY_REPORT,
  UNSET_WORKFORCE_AVAILABILITY_REPORT,
} from "@/store/mutation-types";
import {
  getWorkforceAvailabilityReport,
} from "@/store/api";

const state = {
  workforceAvailabilityReport: [],
};

const getters = {
  getWorkforceAvailabilityReport(state) {
    return state.workforceAvailabilityReport;
  },
};

const mutations = {
  [SET_WORKFORCE_AVAILABILITY_REPORT](state, data) {
    state.workforceAvailabilityReport = data;
  },
  [UNSET_WORKFORCE_AVAILABILITY_REPORT](state) {
    state.workforceAvailabilityReport = [];
  },
};

const actions = {
  getWorkforceAvailabilityReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getWorkforceAvailabilityReport}`, { params: data })
        .then((response) => {
          commit(SET_WORKFORCE_AVAILABILITY_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_WORKFORCE_AVAILABILITY_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

